/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforloaderror3Inputs */

const en_goodforloaderror3 = /** @type {(inputs: Goodforloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not be loaded.`)
};

const de_goodforloaderror3 = /** @type {(inputs: Goodforloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konnte nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "Could not be loaded." |
*
* @param {Goodforloaderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforloaderror3 = /** @type {((inputs?: Goodforloaderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforloaderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforloaderror3(inputs)
	return de_goodforloaderror3(inputs)
});
export { goodforloaderror3 as "goodForLoadError" }